module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "appDiv"
  }, [_c('div', {
    staticClass: "container-fluid fullH",
    attrs: {
      "id": "intro"
    }
  }, [_c('div', {
    staticClass: "row center centerDiv"
  }, [(_vm.loading) ? _c('div', {
    staticClass: "loading"
  }, [_c('h1', [_vm._v("Loading")])]) : _vm._e(), _vm._l((_vm.algorithms), function(a, index) {
    return _c('div', {
      staticClass: "col backEffect",
      class: {
        active: _vm.randNum == index
      }
    }, [_c('p', [_c('router-link', {
      attrs: {
        "to": '/Algorithm/' + a._id.algorithmname
      }
    }, [_vm._v(_vm._s(a._id.algorithmname))])], 1)])
  })], 2), _c('div', {
    staticClass: "bigTitleDiv"
  }, [_c('h1', [_vm._v("AISearch")]), _c('h5', [_vm._v("Metaheuristics are"), _c('TextChanger', {
    attrs: {
      "arr": ['Nature Wisdom', 'a Mith?', 'Fun to Watch', 'Complicated', 'Mysterius']
    }
  })], 1)])]), _c('div', {
    staticClass: "page",
    attrs: {
      "id": "PubPerYear"
    }
  }, [_c('h2', [_vm._v("Publications Per year")]), _c('h5', [_vm._v("Every year more and more scientific works make use of this algorithms")]), _c('br'), _c('PubPerYear', {
    attrs: {
      "algorithmname": ""
    }
  })], 1), (_vm.topDetail.length != 0) ? _c('div', {
    staticClass: "page",
    attrs: {
      "id": "HallOfFame"
    }
  }, [_c('h2', [_vm._v("Hall of Fame")]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col s12",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Algorithm',
          params: {
            AlgName: _vm.topDetail[0].title
          }
        })
      }
    }
  }, [(_vm.topDetail[0].imgUrl) ? _c('img', {
    staticClass: "circle",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "src": _vm.topDetail[0].imgUrl,
      "alt": "alt"
    }
  }) : _vm._e(), _c('h3', {
    staticClass: "metaName bold"
  }, [_vm._v(_vm._s(_vm.algorithms[0]._id.algorithmname))]), _c('h5', [_c('small', [_vm._v("by " + _vm._s(_vm.topDetail[0].author)), _c('br'), _c('small', [_vm._v(_vm._s(_vm.algorithms[0].count) + " References since " + _vm._s(_vm.algorithms[0].countYears[0].year))])])])])]), _c('div', {
    staticClass: "row"
  }, [_c('div', {
    staticClass: "col m6 s12",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Algorithm',
          params: {
            AlgName: _vm.topDetail[2].title
          }
        })
      }
    }
  }, [(_vm.topDetail[1].imgUrl) ? _c('img', {
    staticClass: "circle",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "src": _vm.topDetail[1].imgUrl,
      "alt": "alt"
    }
  }) : _vm._e(), _c('h4', {
    staticClass: "metaName bold"
  }, [_vm._v(_vm._s(_vm.algorithms[1]._id.algorithmname))]), _c('h5', [_c('small', [_vm._v("by " + _vm._s(_vm.topDetail[2].author)), _c('br'), _c('small', [_vm._v(_vm._s(_vm.algorithms[1].count) + " References since " + _vm._s(_vm.topDetail[2].year))])])])]), _c('div', {
    staticClass: "col m6 s12",
    on: {
      "click": function($event) {
        _vm.$router.push({
          name: 'Algorithm',
          params: {
            AlgName: _vm.topDetail[1].title
          }
        })
      }
    }
  }, [(_vm.topDetail[2].imgUrl) ? _c('img', {
    staticClass: "circle",
    staticStyle: {
      "max-width": "200px"
    },
    attrs: {
      "src": _vm.topDetail[2].imgUrl,
      "alt": "alt"
    }
  }) : _vm._e(), _c('h4', {
    staticClass: "metaName bold"
  }, [_vm._v(_vm._s(_vm.algorithms[2]._id.algorithmname))]), _c('h5', [_c('small', [_vm._v("by " + _vm._s(_vm.topDetail[1].author)), _c('br'), _c('small', [_vm._v(_vm._s(_vm.algorithms[2].count) + " References since " + _vm._s(_vm.topDetail[1].year))])])])])])]) : _vm._e(), _c('div', {
    staticClass: "page fullH",
    attrs: {
      "id": "listAll"
    }
  }, [_c('h2', [_vm._v("List 'em All")]), _c('div', {
    staticClass: "container"
  }, [_c('input', {
    directives: [{
      name: "model",
      rawName: "v-model",
      value: (_vm.filter),
      expression: "filter"
    }],
    staticClass: "metaName bold",
    attrs: {
      "type": "text",
      "id": "filter",
      "placeholder": "Algorithm Name"
    },
    domProps: {
      "value": (_vm.filter)
    },
    on: {
      "input": function($event) {
        if ($event.target.composing) { return; }
        _vm.filter = $event.target.value
      }
    }
  })]), _c('div', {
    staticClass: "row centerDiv"
  }, _vm._l((_vm.algorithms), function(a) {
    return (a._id.algorithmname.toLowerCase().includes(_vm.filter.toLowerCase())) ? _c('div', {
      staticClass: "col"
    }, [_c('div', {
      staticClass: "card",
      on: {
        "click": function($event) {
          _vm.$router.push({
            name: 'Algorithm',
            params: {
              AlgName: a._id.algorithmname
            }
          })
        }
      }
    }, [_c('div', {
      staticClass: "card-content"
    }, [_c('p', {
      staticClass: "metaName bold"
    }, [_vm._v(_vm._s(a._id.algorithmname))])])])]) : _vm._e()
  }))])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-0f7825ce"}!./~/vue-loader/lib/template-compiler/preprocessor.js?engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/intro.vue
// module id = 80
// module chunks = 1